/**
 * Labstep
 *
 * @module core/Checkbox
 * @desc Core checkbox component. Wrapper around semantic.
 */

import type React from 'react';
import SemanticCheckbox from 'semantic-ui-react/dist/commonjs/modules/Checkbox';
import type { ICheckboxProps } from './types';

export const Checkbox: React.FC<ICheckboxProps> = ({
  onClick,
  disabled,
  ...rest
}) => (
  <SemanticCheckbox
    data-cy="core/Checkbox"
    onClick={disabled ? undefined : onClick}
    disabled={disabled}
    {...rest}
  />
);
